import { gql } from '@apollo/client';
import { useMutation } from '@tbitop/api';

export const useAufgabeZwischenergebnisErfassen = () => {
  const [executeMutation, { loading, error }] = useMutation(gql`
    mutation AufgabeZwischenergebnisErfassen($id: UUID!,$zwischenergebnisOption: String!,$kommentar: String) {
      aufgabeZwischenergebnisErfassen(id: $id,zwischenergebnisOption: $zwischenergebnisOption,kommentar: $kommentar) {
        id,
        ergebnisOption
        kommentar
        protokoll {
          erstellt
          akteurId
          akteur
          aktion
        }
        status
        objekt {
          id
          aufgabenStatistik {
            anzahl
            status
          }
        }
      }
    }
  `);

  return {
    aufgabeZwischenergebnisErfassen: (id: string, zwischenergebnisOption: string, kommentar: string) => {
      return executeMutation({
        variables: { id, zwischenergebnisOption, kommentar },
        update(cache) {
          cache.evict({ id: 'ROOT_QUERY', fieldName: 'offeneAufgabenStatistik' });
          cache.evict({ id: 'ROOT_QUERY', fieldName: 'objekteSeitenweise' });
          // the integration test will fail if we don't evict Aufgabe as well 🤷‍♂️
          cache.evict({ id: `Aufgabe:${id}` });
        },
      });
    },
    loading,
    error,
  };
};
